"use client";

import { motion } from "framer-motion";
import { ArrowRight, CreditCard, Zap, MessageCircle, Shield } from "lucide-react";

export function FinalCTALP3() {
  return (
    <section id="cta" className="py-24 px-4 sm:px-6 lg:px-8 relative overflow-hidden">
      {/* Dark background */}
      <div className="absolute inset-0 bg-gray-950 dark:bg-gray-950" />

      {/* Glow blobs */}
      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[800px] h-[400px] bg-gradient-to-r from-[#48c1ce]/20 to-[#ec399a]/20 blur-3xl rounded-full" />
      <div className="absolute top-0 left-0 w-64 h-64 bg-[#48c1ce]/10 blur-3xl rounded-full" />
      <div className="absolute bottom-0 right-0 w-64 h-64 bg-[#ec399a]/10 blur-3xl rounded-full" />

      {/* Grid */}
      <div className="absolute inset-0 bg-[linear-gradient(rgba(255,255,255,0.03)_1px,transparent_1px),linear-gradient(90deg,rgba(255,255,255,0.03)_1px,transparent_1px)] bg-[size:32px_32px]" />

      <div className="relative max-w-4xl mx-auto text-center">
        {/* Badge */}
        <motion.div
          initial={{ opacity: 0, y: 16 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.4 }}
          className="inline-flex items-center gap-2 px-3 py-1.5 rounded-full border border-[#48c1ce]/30 bg-[#48c1ce]/10 text-[#48c1ce] text-xs font-bold mb-6"
        >
          <Zap className="w-3 h-3" />
          Comece agora, sem compromisso
        </motion.div>

        {/* H2 */}
        <motion.h2
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.5, delay: 0.05 }}
          className="text-4xl sm:text-5xl lg:text-6xl font-black tracking-tight text-white leading-[1.05] mb-6"
        >
          Seu e-commerce cresce.
          <br />
          <span className="bg-gradient-to-r from-primary via-purple-600 to-pink-600 bg-clip-text text-transparent">
            Seu pós-venda, também.
          </span>
        </motion.h2>

        {/* Subtitle */}
        <motion.p
          initial={{ opacity: 0, y: 16 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.5, delay: 0.1 }}
          className="text-lg text-gray-400 mb-10 max-w-xl mx-auto leading-relaxed"
        >
          Teste grátis por 14 dias. Sem cartão de crédito. Cancele quando quiser. Configure em menos de 5 minutos.
        </motion.p>

        {/* CTA Button */}
        <motion.div
          initial={{ opacity: 0, scale: 0.95 }}
          whileInView={{ opacity: 1, scale: 1 }}
          viewport={{ once: true }}
          transition={{ duration: 0.4, delay: 0.15 }}
          className="flex flex-col sm:flex-row items-center justify-center gap-4 mb-10"
        >
          <a
            href="/register"
            className="group flex items-center gap-2.5 px-8 py-4 rounded-2xl bg-gradient-to-r from-[#48c1ce] to-[#3aafbc] hover:from-[#3aafbc] hover:to-[#48c1ce] text-white font-black text-lg transition-all duration-300 shadow-2xl shadow-[#48c1ce]/40 hover:shadow-[#48c1ce]/60 hover:-translate-y-1"
          >
            Começar Grátis — 14 dias
            <ArrowRight className="w-5 h-5 group-hover:translate-x-1 transition-transform" />
          </a>
          <a
            href="#"
            className="flex items-center gap-2 px-6 py-4 rounded-2xl border border-white/20 text-white/70 hover:text-white hover:border-white/40 font-semibold text-base transition-all duration-200"
          >
            <MessageCircle className="w-4 h-4" />
            Falar com especialista
          </a>
        </motion.div>

        {/* Trust badges */}
        <motion.div
          initial={{ opacity: 0 }}
          whileInView={{ opacity: 1 }}
          viewport={{ once: true }}
          transition={{ duration: 0.5, delay: 0.25 }}
          className="flex flex-wrap items-center justify-center gap-x-6 gap-y-3"
        >
          {[
            { icon: CreditCard, text: "Sem cartão de crédito" },
            { icon: Zap, text: "Pronto em 5 minutos" },
            { icon: Shield, text: "Dados 100% seguros" },
            { icon: MessageCircle, text: "Suporte humano incluso" },
          ].map(({ icon: Icon, text }) => (
            <div key={text} className="flex items-center gap-1.5 text-xs font-semibold text-gray-500">
              <Icon className="w-3.5 h-3.5 text-[#48c1ce]" />
              {text}
            </div>
          ))}
        </motion.div>
      </div>
    </section>
  );
}
